export default __webpack_public_path__ + "static/media/Robot3.ff9c403a.png";